var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2421 8.64584C13.1958 8.64584 11.5761 7.4562 9.87047 7.4992C7.62017 7.52786 5.55621 8.8035 4.39523 10.8245C2.05893 14.8808 3.79324 20.872 6.0722 24.1686C7.19018 25.7739 8.50882 27.5799 10.2575 27.5225C11.9344 27.4509 12.5651 26.4332 14.6004 26.4332C16.6214 26.4332 17.1947 27.5225 18.972 27.4795C20.778 27.4509 21.9246 25.8456 23.0283 24.2259C24.3039 22.3626 24.8342 20.5567 24.8629 20.4563C24.8199 20.442 21.3513 19.109 21.3083 15.0958C21.2796 11.7418 24.0459 10.1365 24.1749 10.0648C22.5983 7.75719 20.176 7.4992 19.3303 7.44187C17.123 7.26987 15.2741 8.64584 14.2421 8.64584ZM17.9687 5.26324C18.9003 4.14526 19.5167 2.58295 19.3447 1.03497C18.0117 1.09231 16.4064 1.92363 15.4461 3.04161C14.5861 4.03059 13.8408 5.62156 14.0414 7.14087C15.5177 7.25554 17.037 6.38122 17.9687 5.26324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.1fec8b504e93ee533a7f424933689e37.svg";
export { ForwardRef as ReactComponent };